import yup from '../yup';

export const updateSiteSchema = yup.object().shape({
  title: yup.string()
    .nullable()
    .required('サイト名を入力してください。')
    .label('サイト名'),
});
